import PropTypes from 'prop-types'
import { Field, useFormikContext } from 'formik'

import Autocomplete from 'components/Autocomplete'

const BelongsToModifierGroups = ({ modifierGroups, belongsToModifierGroupUuids, id }) => {
  const { setFieldValue } = useFormikContext()


  return (
    <section id={id}>
      <h3 id={id} className="header-title">
        Belongs To Modifier Groups
      </h3>
      <span>Use when adding this item to a modifier group(s)</span>
      <div className="content-wrapper -multi-select-wrapper">
        <span className="content-value">
          <Field
            handleValueChange={(value) =>
              setFieldValue('belongsToModifierGroupUuids', value)
            }
            value={belongsToModifierGroupUuids}
            component={Autocomplete}
            data={modifierGroups}
            isMulti={true}
            name="belongsToModifierGroupUuids"
            placeholder="Belongs To Modifier Groups"
            type="select"
          />
        </span>
      </div>
    </section>
  )
}

BelongsToModifierGroups.propTypes = {
  id: PropTypes.string,
}

export default BelongsToModifierGroups
